import Service, { service } from '@ember/service'
import EventTrackerService from 'customer-flows/services/event-tracker'

export abstract class Tracker extends Service {
  @service eventTracker: EventTrackerService

  protected abstract readonly supportedEvents: TrackingEventName[]

  abstract setup(): void | Promise<void>

  abstract track<E extends TrackingEventName>(_event: E, _props: EventProps<E>): void

  handles(event: TrackingEventName): boolean {
    return this.supportedEvents.includes(event)
  }

  get isEnabled(): boolean {
    return true
  }
}
